<template>
  <div class="modal-card" style="width: 1200px">
    <header class="modal-card-head">
      <p class="modal-card-title is-centered">
        {{ $t('attributes.select') + $t('attributes.product') }}
      </p>
    </header>
    <section class="modal-card-body">
      <nav class="columns">
        <div class="column">
          <b-field grouped group-multiline>
            <b-field>
              <b-select
                v-model="selectedArea"
                :loading="loadingAreas"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                @input="onSelectArea"
              >
                <option value="">
                  {{ $t('attributes.all_area') }}
                </option>
                <option
                  v-for="option in areas"
                  :value="option"
                  :key="option.code"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field>
              <b-select
                v-model="selectedCatalog"
                :loading="loadingAreas"
                :disabled="catalogs.length <= 0"
                :placeholder="
                  $t('message.please_select') + $t('attributes.catalog')
                "
                @input="onSelectCatalog"
              >
                <option value="">全部類別</option>
                <option
                  v-for="option in catalogs"
                  :value="option"
                  :key="option.catalog_no"
                >
                  {{ !option.status ? '[下架]' : '' }}
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field>
              <p class="control">
                <span class="button is-static">
                  {{ $t('attributes.activation_status') }}
                </span>
              </p>
              <b-select v-model="filterStatus" @input="onFilterStatus">
                <option value="all">{{ $t('attributes.all') }}</option>
                <option value="true">{{ $t('attributes.shelve_on') }}</option>
                <option value="false">{{ $t('attributes.shelve_off') }}</option>
              </b-select>
            </b-field>
          </b-field>
        </div>
      </nav>

      <b-table
        :data="items"
        :loading="isLoading"
        :hoverable="true"
        :narrowed="true"
        :mobile-cards="true"
        scrollable
        :total="total"
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
      >
        <b-table-column
          field="code"
          :label="$t('attributes.product_code')"
          width="120"
          sortable
          centered
          v-slot="props"
        >
          <b-button
            type="is-text"
            style="padding: 0;"
            @click="onSelectProduct(props.row)"
          >
            {{ props.row.code }}
          </b-button>
        </b-table-column>

        <b-table-column
          field="shelve_on"
          :label="$t('attributes.activation_status')"
          width="75"
          sortable
          centered
          v-slot="props"
        >
          <b-tag
            :type="props.row.shelve_on ? 'is-info' : 'is-danger'"
            size="is-medium"
          >
            {{ shelveStatus(props.row.shelve_on) }}
          </b-tag>
        </b-table-column>

        <b-table-column
          field="name"
          :label="$t('attributes.name')"
          sortable
          v-slot="props"
        >
          <b-button
            type="is-text"
            style="padding: 0; white-space: normal; text-align: left; height: auto;"
            @click="onSelectProduct(props.row)"
          >
            <p v-html="props.row.name"></p>
          </b-button>
        </b-table-column>

        <b-table-column
          field="updated_at"
          :label="$t('attributes.modify_date')"
          width="200"
          sortable
          centered
          v-slot="props"
        >
          {{ formatDate(props.row.updated_at) }}
        </b-table-column>

        <template #empty>
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { AREA_API, PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'ProductSelector',

  data() {
    const productTypes = this.GetProductTypes()

    return {
      productTypes,
      loadingItems: false,
      total: 0,
      items: [],

      filterStatus: 'true',
      sortField: 'code',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',

      loadingAreas: false,
      areas: [],
      catalogs: [],
      selectedArea: null,
      selectedAreaCode: null,
      selectedCatalog: null,
      selectedCatalogNo: null
    }
  },
  computed: {
    isLoading() {
      return this.loadingItems || this.loadingAreas
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.catalogs = []
        this.selectedArea = null
        this.selectedAreaCode = null
        this.selectedCatalog = null
        this.selectedCatalogNo = null
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null
        this.selectedAreaCode = null
        this.selectedCatalog = null
        this.selectedCatalogNo = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async loadProducts() {
      try {
        const api = `${PRODUCTS_API}/list`

        const params = {
          area: this.selectedAreaCode,
          catalog: this.selectedCatalogNo,
          status: this.filterStatus === 'all' ? null : this.filterStatus
        }

        this.loadingItems = true
        const res = await this.axios.get(api, { params })
        this.items = res.data.data
        this.total = this.items.length
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('product', e)
      } finally {
        this.loadingItems = false
      }
    },
    onSelectArea(option) {
      this.selectedArea = option
      this.selectedAreaCode = option ? option.code : null
      this.catalogs = option ? option.catalogs : []
      this.selectedCatalog = null
      this.selectedCatalogNo = null
    },
    onSelectCatalog(option) {
      this.selectedCatalog = option
      this.selectedCatalogNo = option ? option.catalog_no : null

      this.loadProducts()
    },
    onFilterStatus() {
      if (this.selectedArea && this.selectedCatalog) {
        this.loadProducts()
      }
    },
    onSelectProduct(product) {
      this.$emit(
        'selected',
        product,
        this.selectedAreaCode,
        this.selectedCatalogNo
      )
    }
  }
}
</script>
